import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrinter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPrinter2"><Path fillRule="evenodd" clipRule="evenodd" d="M17 21H7V8H17V21ZM10 16.5H12.5V15H10V16.5ZM10 12.5H14V11H10V12.5Z" fill="currentColor"/><Path d="M22 13H18.5V6.5H5.5V13H2V3H22V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrinter2;
